import { render } from "./SettingsLayout.vue?vue&type=template&id=3fd3b528"
import script from "./SettingsLayout.vue?vue&type=script&lang=js"
export * from "./SettingsLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__